module.exports = __webpack_public_path__ + "static/media/computers.33dbccd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/computers.png
// module id = 926
// module chunks = 0